import { request, isMockMode, mockResponse } from './client.js';

// 會員等級 API。與使用者/角色同屬後台會員管理，共用 isMockMode('roles') 開關。
// Level 形狀：{ id, level(數字門檻，越大越高), name }

let _levels = [
  { id: 1, level: 0, name: '一般' },
  { id: 2, level: 1, name: 'VIP1' },
  { id: 3, level: 2, name: 'VIP2' },
];
let _nextId = 4;

export function getMembershipLevels() {
  if (!isMockMode('roles')) return request('/api/membership-levels');
  return mockResponse(() => _levels.map(l => ({ ...l })));
}

export function adminCreateLevel({ level, name }) {
  if (!isMockMode('roles')) {
    return request('/api/admin/membership-levels', { method: 'POST', body: { level, name } });
  }
  return mockResponse(() => {
    const l = { id: _nextId++, level: Number(level), name };
    _levels = [..._levels, l].sort((a, b) => a.level - b.level);
    return { ...l };
  });
}

export function adminUpdateLevel(id, { name }) {
  if (!isMockMode('roles')) {
    return request(`/api/admin/membership-levels/${id}`, { method: 'PATCH', body: { name } });
  }
  return mockResponse(() => {
    const l = _levels.find(x => x.id === id);
    if (l) l.name = name;
    return l ? { ...l } : null;
  });
}

export function adminDeleteLevel(id) {
  if (!isMockMode('roles')) {
    return request(`/api/admin/membership-levels/${id}`, { method: 'DELETE' });
  }
  return mockResponse(() => { _levels = _levels.filter(x => x.id !== id); return null; });
}
